import React from "react";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
import { Link, useLocation } from "react-router-dom";
import BackSections from "../Giftcards/BackSections";

const OrderAlternatePage  = () => {
    const translation = getTranslationData();
    const location = useLocation();

  return (
    <>
    {location?.state?.orderDetails && <BackSections />}
      <div className={`voucher-container col-lg-10 col-12 ${location?.state?.orderDetails && 'container col-lg-12 mt-4'}`}>
        <div className="voucher-card">
          <h2 className="voucher-title">{translation?.hang_tight}</h2>
          <p className="voucher-text">{translation?.order_proccessing_message}
          </p>
          <Link to="/" >
          <button className="voucher-button">{translation?.continue_shopping}</button>
          </Link>
        </div>
      </div>
    </>
  );
};

export default OrderAlternatePage ;
